<template lang="pug">
  .number-input
    button.number-input__minus(@click="onMinus")
      v-icon(name="minus")
    input.number-input__input(
      v-model="state"
      @blur="onBlur"
      :id="id"
      ref="input"
    )
    button.number-input__plus(@click="onPlus")
      v-icon(name="plus")
</template>

<script>
export default {
  name: 'NumberInput',
  props: {
    value: {
      default: 0,
      validator: (value) => typeof value === 'number'
    },
    minValue: {
      default: 0,
      validator: (value) => typeof value === 'number'
    },
    maxValue: {
      default: 0,
      validator: (value) => typeof value === 'number'
    },
    id: {
      type: String,
    }
  },
  data() {
    return {
      state: 0,
    }
  },
  watch: {
    value(newVal) {
      this.state = newVal;
    },
    state: {
      handler(newVal) {
        this.state = parseInt(newVal);
        this.state = this.state || this.state === 0 ? this.state : '';

        if (newVal < this.minValue) {
          this.state = this.minValue;
        }
        if (newVal > this.maxValue) {
          this.state = this.maxValue;
        }

        if (this.state === '') {
          return this.$emit('input', 0);
        }
        this.$emit('input', this.state);
      },
      immediate: true
    }
  },
  mounted() {
    this.state = this.value;
  },
  methods: {
    onPlus() {
      this.state = this.state >= this.maxValue ? this.state : this.state + 1;
    },
    onMinus() {
      this.state = this.state <= this.minValue ? this.state : this.state - 1;
    },
    onBlur() {
      if (this.state === '') {
        this.$refs.input.value = '0'
      }
    }
  }
}
</script>

